export const HEADER_SECTION_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/engineering-systems';

export const BANNER_IMAGE = {
  srcDPlus: `${HEADER_SECTION_CDN_PATH}/banner/v2-dPlus.jpg/v2-dPlus.jpg`,
  srcD: `${HEADER_SECTION_CDN_PATH}/banner/v2-d.jpg/v2-d.jpg`,
  srcT: `${HEADER_SECTION_CDN_PATH}/banner/v2-t.jpg/v2-t.jpg`,
  srcM: `${HEADER_SECTION_CDN_PATH}/banner/v2-m.jpg/v2-m.jpg`,
  alt: 'Баннер инженерных систем',
};
